// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {287: "1db4c89c49531a38",4775: "012cd854110cd98d",}[chunkId] + ".css"
}